/**
 * Bidirectional host mappings between legacy Azure / FD hosts and enact.lcp.com proxy paths.
 * Used when looking up endpointToEarliestBufferDate keys that may be stored under either host form.
 */
export const endpointHostPairs: Array<[string, string]> = [
    ['enactapifd.lcp.uk.com', 'enact.lcp.com/gb'],
    ['enact-main.azurefd.net', 'enact.lcp.com/gb'],
    ['enactapifd.lcp.uk.com', 'enact-main.azurefd.net'],
    ['enact-signalrhub.azurewebsites.net', 'enact.lcp.com/signalr'],
    ['enact-epex.azurefd.net', 'enact.lcp.com/epexgb'],
    ['enact-epex-france-prd-uksouth-app.azurewebsites.net', 'enact.lcp.com/epexfrance'],
    ['enact-europe.azurefd.net', 'enact.lcp.com/europe'],
    ['enact-static.azurefd.net', 'enact.lcp.com/static'],
    ['enact-calculatorapi-one.azurewebsites.net', 'enact.lcp.com/calculator'],
    ['enact-semoapi.azurewebsites.net', 'enact.lcp.com/ireland'],
    ['enact-franceapi.azurewebsites.net', 'enact.lcp.com/france'],
    ['enact-belgiumapi.azurewebsites.net', 'enact.lcp.com/belgium'],
    ['enact-netherlandsapi.azurewebsites.net', 'enact.lcp.com/netherlands'],
    ['enact-functionapp-siteapi.azurewebsites.net', 'enact.lcp.com/series'],
    ['enact-carboncalculatorpremium-prd-ukd-func.azurewebsites.net', 'enact.lcp.com/free'],
    ['enact-staticchartapi.azurewebsites.net', 'enact.lcp.com/staticchart'],
];

export function getEndpointHostPairCandidates (endpoint: string): Array<string> {
    const candidates: Array<string> = [];

    endpointHostPairs.forEach(([oldHost, newHost]) => {
        if (endpoint.includes(oldHost)) {
            candidates.push(endpoint.replace(oldHost, newHost));
        }
        if (endpoint.includes(newHost)) {
            candidates.push(endpoint.replace(newHost, oldHost));
        }
    });

    return candidates.filter((candidate, index, arr) => candidate != null && arr.indexOf(candidate) === index);
}

export function findEndpointBufferDateKey (
    endpoint: string,
    endpointToEarliestBufferDate: Record<string, unknown>,
): string | null {
    const endpointKey = endpoint.toLowerCase();
    if (Object.prototype.hasOwnProperty.call(endpointToEarliestBufferDate, endpointKey)) {
        return endpointKey;
    }

    const fallbackKey = getEndpointHostPairCandidates(endpointKey)
        .find(candidate => Object.prototype.hasOwnProperty.call(endpointToEarliestBufferDate, candidate));

    return fallbackKey ?? null;
}
